import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ComparisonModal = ({ influencers, onClose, onRemove }) => {
  if (influencers?.length === 0) return null;

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return `${(num / 1000000)?.toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000)?.toFixed(1)}K`;
    }
    return num?.toString();
  };

  const metrics = [
    { key: 'followers', label: 'Takipçi Sayısı', icon: 'Users', format: formatNumber },
    { key: 'engagementRate', label: 'Etkileşim Oranı', icon: 'TrendingUp', format: (v) => `%${v}` },
    { key: 'avgViews', label: 'Ortalama Görüntülenme', icon: 'Eye', format: formatNumber },
    { key: 'avgLikes', label: 'Ortalama Beğeni', icon: 'Heart', format: formatNumber },
    { key: 'responseTime', label: 'Yanıt Süresi', icon: 'Clock', format: (v) => v },
    { key: 'completedCampaigns', label: 'Tamamlanan Kampanya', icon: 'CheckCircle', format: (v) => v },
    { key: 'rating', label: 'Değerlendirme', icon: 'Star', format: (v) => `${v}/5.0` },
    { key: 'startingPrice', label: 'Başlangıç Fiyatı', icon: 'DollarSign', format: (v) => `₺${v?.toLocaleString('tr-TR')}` }
  ];

  return (
    <div className="fixed inset-0 z-[1400] bg-background/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-elevation-3 w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold text-foreground">
              Influencer Karşılaştırması
            </h2>
            <p className="text-sm text-muted-foreground mt-1">
              {influencers?.length} influencer karşılaştırılıyor
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
          >
            <Icon name="X" size={20} />
          </Button>
        </div>

        <div className="flex-1 overflow-auto p-6">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="text-left p-4 bg-muted/50 sticky left-0 z-10">
                    <span className="text-sm font-medium text-muted-foreground">
                      Metrik
                    </span>
                  </th>
                  {influencers?.map((influencer) => (
                    <th key={influencer?.id} className="p-4 bg-muted/50 min-w-[200px]">
                      <div className="flex flex-col items-center gap-3">
                        <div className="relative">
                          <div className="w-16 h-16 rounded-full overflow-hidden bg-muted">
                            <Image
                              src={influencer?.avatar}
                              alt={influencer?.avatarAlt}
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <button
                            onClick={() => onRemove(influencer?.id)}
                            className="absolute -top-1 -right-1 w-6 h-6 bg-error text-error-foreground rounded-full flex items-center justify-center hover:bg-error/90 transition-smooth"
                            aria-label="Karşılaştırmadan çıkar"
                          >
                            <Icon name="X" size={12} />
                          </button>
                        </div>
                        <div className="text-center">
                          <p className="font-semibold text-foreground text-sm">
                            {influencer?.name}
                          </p>
                          <p className="text-xs text-muted-foreground">
                            @{influencer?.username}
                          </p>
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {metrics?.map((metric, index) => (
                  <tr key={metric?.key} className={index % 2 === 0 ? 'bg-muted/20' : ''}>
                    <td className="p-4 sticky left-0 bg-card border-r border-border">
                      <div className="flex items-center gap-2">
                        <Icon name={metric?.icon} size={16} color="var(--color-muted-foreground)" />
                        <span className="text-sm font-medium text-foreground">
                          {metric?.label}
                        </span>
                      </div>
                    </td>
                    {influencers?.map((influencer) => (
                      <td key={influencer?.id} className="p-4 text-center">
                        <span className="text-sm text-foreground font-medium">
                          {metric?.format(influencer?.[metric?.key])}
                        </span>
                      </td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <td className="p-4 sticky left-0 bg-card border-r border-border">
                    <div className="flex items-center gap-2">
                      <Icon name="Tag" size={16} color="var(--color-muted-foreground)" />
                      <span className="text-sm font-medium text-foreground">
                        Kategoriler
                      </span>
                    </div>
                  </td>
                  {influencers?.map((influencer) => (
                    <td key={influencer?.id} className="p-4">
                      <div className="flex flex-wrap gap-1 justify-center">
                        {influencer?.categories?.slice(0, 3)?.map((category, idx) => (
                          <span
                            key={idx}
                            className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full"
                          >
                            {category}
                          </span>
                        ))}
                      </div>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="p-6 border-t border-border bg-muted/20">
          <div className="flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={onClose}
            >
              Kapat
            </Button>
            <Button
              variant="default"
              iconName="Send"
              iconPosition="right"
            >
              Toplu Teklif Gönder
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonModal;